import { showCustomerService } from "@/components/vendors";
import { getCreateAccountPath } from "@/modules/onboarding";
import Error from "./errors";

export default function MissingAccount() {
  return (
    <Error
      title="Missing Account"
      description="It looks like you don't have an active account to access the application."
      actionText="Create Account"
      actionHref={getCreateAccountPath()}
    >
      <p className="mb-10 text-sm text-gray-700">
        If you already have an account,{" "}
        <a onClick={showCustomerService} className="underline">
          contact us
        </a>{" "}
        for assistance.
      </p>
    </Error>
  );
}
